function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
/* eslint-disable */

const CloseIcon = ({
  style = {},
  fill = '#3c3c3c',
  viewBox = '0 0 18 18',
  width = '100%',
  className = '',
  height = '100%',
  ...rest
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: width,
  style: style,
  height: height,
  className: className,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: viewBox,
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, rest), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "close-icon-clip-path"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#3c3c3c",
  d: "M0 0H18V18H0z"
}))), /*#__PURE__*/React.createElement("g", {
  "clip-path": "url(#close-icon-clip-path)",
  fill: fill,
  "fill-rule": "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M122 0a9 9 0 1 0 9 9 9 9 0 0 0-9-9zm0 16.578A7.578 7.578 0 1 1 129.578 9 7.578 7.578 0 0 1 122 16.578z",
  transform: "translate(-113)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(4.824 4.77)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M147.09 26.5l-3.1 3.078-3.074-3.078-1.116 1.116 3.078 3.078-3.078 3.1 1.116 1.116 3.078-3.078 3.1 3.078 1.116-1.116-3.078-3.1 3.078-3.078z",
  transform: "translate(-139.8 -26.5)"
}))));

export default CloseIcon;